import { Tooltip } from '@base-ui/react';
import styled from '@emotion/styled';

import { zIndex } from '../../z-index';

export const StyledPositioner = styled(Tooltip.Positioner)({
  zIndex: zIndex.tooltip,
});

export const StyledPopup = styled(Tooltip.Popup)(({ theme }) => ({
  color: theme.colors.text.primary,
  fontFamily: 'DM Sans, sans-serif',
  fontSize: '12px',
  lineHeight: '16px',
  letterSpacing: '0.015em',
  fontWeight: 400,
  wordWrap: 'break-word',

  padding: '4px 8px',
  background: theme.colors.background.overlay,
  borderRadius: '8px',
  boxShadow: theme.shadows.md,
  maxWidth: '300px',
}));

export const StyledArrow = styled(Tooltip.Arrow)(({ theme }) => ({
  color: theme.colors.background.overlay,
  display: 'flex',

  '&[data-side="top"]': {
    bottom: -5,
    rotate: '0deg',
  },
  '&[data-side="bottom"]': {
    top: -5,
    rotate: '180deg',
  },
  '&[data-side="left"]': {
    right: -8,
    rotate: '-90deg',
  },
  '&[data-side="right"]': {
    left: -8,
    rotate: '90deg',
  },
}));
